export default "__VITE_PUBLIC_ASSET__42d71a42__"